<nv-modal #loginModal (closed)="onDismiss()">
  <ng-template modalContent>
    <h3 class="mb-3">{{ 'APP.' + (sessionExpired ? 'LOGIN_AFTER_LOGOUT' : 'LOGIN') + '.TITLE' | translate }}</h3>
    <p>{{ sessionExpired ? ('APP.LOGIN_AFTER_LOGOUT.TEXT' | translate) : '' }}</p>
    <nv-user-login-form (loginSuccess)="onSuccess()" [kupoUrl]="kupoUrl"></nv-user-login-form>
  </ng-template>
</nv-modal>
